import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import React from 'react';
import {
  extendClassName,
  formattedPriceStringFromMicroCurrency,
} from 'utils/common';
import { colors } from 'utils/constants';

interface INewPlanSelector {
  additionalClassName?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const NewPlanSelector = observer(
  ({ style, disabled, additionalClassName }: INewPlanSelector) => {
    const { plan, num_entries, setNumEntries } = useEnterStore();

    const planEntries = plan && plan.priceTable[plan.priceVersion]['GBP'];

    return (
      planEntries &&
      Object.keys(planEntries).length > 1 && (
        <div>
          <p className={`big-font-desktop-p text-center`}>
            The more entries, the more chances to win!
          </p>
          <div
            className={extendClassName(
              'newPlanSelector flexCentered',
              additionalClassName
            )}
            style={style}
          >
            {Object.keys(planEntries).map((entries) => {
              const entriesValue = parseInt(entries);
              return (
                <div
                  key={entries}
                  className={`planOption !rounded-xl flexCentered noSelect${
                    num_entries === entriesValue ? ' selected' : ''
                  }`}
                  onClick={() => !disabled && setNumEntries(entriesValue)}
                >
                  {entriesValue === 2 && (
                    <div
                      className={`mostPopularBadge ${
                        num_entries === entriesValue
                          ? '!bg-white !border-solid !border-2 !border-zinc-700'
                          : ''
                      }`}
                    >
                      <p className="xsmall bold noMargin uppercase w-28 text-center">
                        <span
                          style={{ fontSize: '0.8em' }}
                          className={`${
                            num_entries === entriesValue
                              ? 'text-zinc-700'
                              : 'text-white'
                          }`}
                        >
                          Popular{' '}
                        </span>
                      </p>
                    </div>
                  )}

                  <div className="contentContainer flexCentered">
                    <p
                      className={'xlarge uppercase noMargin font-black'}
                      style={{
                        marginBottom: '0.25em',
                        fontSize: 20,
                        fontFamily: 'Montserrat-Black, Montserrat !important',
                      }}
                    >
                      {entriesValue} {entriesValue === 1 ? 'entry' : 'entries'}
                    </p>

                    <p className="xsmall bold italic">
                      {formattedPriceStringFromMicroCurrency(
                        planEntries[entries] * 100
                      )}{' '}
                      {entriesValue > 1 ? 'each' : ''}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          <style jsx>
            {`
              .big-font-desktop-p {
                font-size: 14px;
              }

              .newPlanSelector {
                width: 100%;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 1em;
                align-items: center;
                justify-content: center;
                justify-items: center;
                align-content: center;
              }

              .newPlanSelector p {
                color: ${colors.primaryBrandGray}90;
              }

              .planOption {
                width: 100%;
                border: 3px solid #e5e5e5;
                border-radius: 5px;
                cursor: ${disabled ? 'default' : 'pointer'};
                position: relative;
              }

              .planOption.selected {
                width: 100%;
                border: 3px solid ${colors.primaryBrandGray};
                background: ${colors.primaryBrandGray};
                cursor: ${disabled ? 'default' : 'pointer'};
              }

              .contentContainer {
                width: 100%;
                padding: 1.4em 0;
              }

              .mostPopularBadge {
                position: absolute;
                top: -1em;
                background: #4a4a4a;
                border-radius: 25px;
                padding: 0.5em 1em;
              }

              .mostPopularBadge p {
                color: white;
                line-height: 1;
              }

              .planOption.selected h4,
              .planOption.selected p {
                color: white;
              }

              .planOption.selected .mostPopularBadge p {
                color: white;
              }

              @media (min-width: 800px) {
                .big-font-desktop-p {
                  font-size: 20px !important;
                }
              }
            `}
          </style>
        </div>
      )
    );
  }
);

export default NewPlanSelector;
